import type React from 'react';

import { Alert, Button, Text } from '@change/ds-core-ui';

import { useEmailDecisionMakerNotification } from './hooks/useEmailDecisionMakerNotification';

type Props = {
	onDismiss?: () => void;
};

export const EmailDecisionMaker: React.FC<Props> = ({ onDismiss }) => {
	const { actions } = useEmailDecisionMakerNotification({ onDismiss });

	return (
		<Alert
			className="h-full w-full [&>div>div]:flex-row"
			variant="info"
			heading="Contact Your Decision Maker"
			{...(onDismiss && {
				onDismissClick: actions.handleDismiss,
				dismissButtonAriaLabel: 'Close email decision maker notification',
			})}
			data-qa="starter-can-email-dm-section-message"
		>
			<Text as="p">Emailing decision makers makes it more likely that your petitions will be successful.</Text>
			<Button className="mt-4" size="x-small" variant="secondary-solid" onClick={actions.handleClick}>
				Email your decision maker
			</Button>
		</Alert>
	);
};
